import 'core-js/stable';
import 'regenerator-runtime/runtime';
import 'chart.js';

import 'bootstrap';

import T from 'i18n-react';

import moment from 'moment';

import '@fontsource/roboto';

import '../scss/front.scss';
// Old assets from asset pipeline
// Don't use these styles
import '../scss/assets/front.scss';

// CKEditor 5 stylesheet
import '@ckeditor/ckeditor5-heading/theme/heading.css';
import '@ckeditor/ckeditor5-font/theme/fontsize.css';
import '@ckeditor/ckeditor5-horizontal-line/theme/horizontalline.css';
import '@ckeditor/ckeditor5-table/theme/table.css';
import '@ckeditor/ckeditor5-media-embed/theme/mediaembed.css';
import '@ckeditor/ckeditor5-image/theme/image.css';
import '@ckeditor/ckeditor5-image/theme/imagestyle.css';
import '@ckeditor/ckeditor5-image/theme/imagecaption.css';

// PWA Manifest
import '../src/front/manifest.json';

require('turbolinks').start();

const ReactRailsUJS = require('../src/react_ujs_wrapper')(
  require.context('components/front', true),
  require('../src/front/ThemeProvider/withFrontTheme').default,
);

global.$ = jQuery;

// Remove previous event handlers and add new ones:
ReactRailsUJS.detectEvents();

require('@rails/ujs').start();

function importAll(r) {
  r.keys().forEach(r);
}
const merge = require('lodash/merge');
T.setTexts(
  merge(
    {},
    require('../src/core/locales/ja.json'),
    require('../src/user_review/locales/ja.json'),
    require('../src/front/locales/ja.json'),
  ),
);
moment.locale('ja');

importAll(require.context('../src/front/', true, /\.(jsx?|tsx?)$/));

importAll(require.context('../src/lib/', true, /\.jsx?$/));

importAll(require.context('../images', true));
